$(() => {
  const peselInput = document.getElementById("registration_user_pesel");
  const noPeselCheckbox = document.getElementById("registration_user_no_pesel");
  if (noPeselCheckbox) {
    noPeselCheckbox.addEventListener("change", (event) => {
      const { checked } = event.target;
      if (checked) {
        peselInput.disabled = true;
        peselInput.value = "";
      } else {
        peselInput.disabled = false;
      }
    });
  }
});
document.addEventListener("DOMContentLoaded", function() {
  let isAdultSelect = document.querySelector("#registration_user_is_adult");
  if (!isAdultSelect) {
    isAdultSelect = document.querySelector('select[name*="is_adult"]');
  }
  if (!isAdultSelect) {
    isAdultSelect = document.querySelector('select[id*="is_adult"]');
  }
  const tosLink = document.querySelector("#tos-link");
  const ppLink = document.querySelector("#pp-link");
  const guardianEmailField = document.querySelector("#guardian-email-field");
  const adultAgreements = document.getElementById("adult_agreements");
  const nonAdultAgreements = document.getElementById("non_adult_agreements");
  function handleIsAdultChange(isAdultValue) {
    if (isAdultValue === "false") {
      if (tosLink) tosLink.href = tosLink.dataset.minorPath;
      if (ppLink) ppLink.href = ppLink.dataset.minorPath;
    } else if (isAdultValue === "true") {
      if (tosLink) tosLink.href = tosLink.dataset.adultPath;
      if (ppLink) ppLink.href = ppLink.dataset.adultPath;
    } else {
      if (tosLink) tosLink.href = tosLink.dataset.adultPath;
      if (ppLink) ppLink.href = ppLink.dataset.adultPath;
    }
    if (guardianEmailField) {
      if (isAdultValue === "false") {
        guardianEmailField.style.display = "block";
      } else {
        guardianEmailField.style.display = "none";
        if (isAdultValue !== "") {
          const emailInput = guardianEmailField.querySelector('input[type="email"]');
          if (emailInput) {
            emailInput.value = "";
          }
        }
      }
    }
    if (adultAgreements) {
      if (isAdultValue === "true") {
        adultAgreements.style.display = "block";
      } else {
        adultAgreements.style.display = "none";
      }
    }
    if (nonAdultAgreements) {
      if (isAdultValue === "false") {
        nonAdultAgreements.style.display = "block";
      } else {
        nonAdultAgreements.style.display = "none";
      }
    }
  }
  if (isAdultSelect) {
    const initialValue = isAdultSelect.value;
    if (initialValue) {
      handleIsAdultChange(initialValue);
    }
    isAdultSelect.addEventListener("change", function() {
      handleIsAdultChange(this.value);
    });
  }
});
